import { useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Button, Card, Field, Input } from "@aigntx/ui";
import { endpoints } from "../api";
import { useTenant } from "../tenant";
import { ThemeControls } from "../ThemeControls";
import { BrandMark } from "../BrandMark";

export function ForgotPage() {
  const { t } = useTranslation();
  const tenant = useTenant();
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);
  const [resetPath, setResetPath] = useState<string | null>(null);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setBusy(true);
    try {
      const r = await endpoints.forgotPassword(email.trim());
      setSent(true);
      setResetPath(r.resetUrl ? r.resetUrl.replace(/^https?:\/\/[^/]+/, "") : null);
    } catch {
      setSent(true); // never reveal whether the email exists
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="auth">
      <div className="auth__top">
        <ThemeControls />
      </div>
      <Card className="auth__card">
        <div className="auth__brand">
          <BrandMark icon={tenant.theme.icon} size={34} />
          <span className="brand__name">{tenant.name}</span>
        </div>
        <h1 className="auth__title">{t("forgot.title")}</h1>
        <p className="auth__sub">{t("forgot.subtitle")}</p>

        {sent ? (
          <div className="auth__form">
            <div className="form-ok">{t("forgot.sent")}</div>
            {resetPath && (
              <div className="dev-note">
                {t("forgot.devLink")}{" "}
                <Link to={resetPath}>{t("forgot.openReset")}</Link>
              </div>
            )}
            <Link className="auth__link" to="/login">
              {t("forgot.backToLogin")}
            </Link>
          </div>
        ) : (
          <form className="auth__form" onSubmit={submit}>
            <Field label={t("login.email")}>
              <Input
                type="email"
                autoComplete="username"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </Field>
            <Button type="submit" block loading={busy}>
              {t("forgot.submit")}
            </Button>
            <Link className="auth__link" to="/login">
              {t("forgot.backToLogin")}
            </Link>
          </form>
        )}
      </Card>
    </div>
  );
}
